export default __webpack_public_path__ + "static/media/ahp-logo.1b76f4c9.png";